// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1b991356","879":"90975366","977":"4b3215a8"}[chunkId] + ".chunk.js";
};